import React, { useMemo } from "react";
import { AiccScenarioCategory, AiccScenarioCategoryPayload } from "types/model/aiccLearningAssets";
import { aiccScenarioCategoryApi } from "services/aiccLearningAssets";
import ScenarioCategoryModal from "./ScenarioCategoryModal";
import getColumns from "./columnConfig";
import LearningAssetPage from "../LearningAssetPage";
import { useAssetCrud } from "../hooks/useAssetCrud";
import { useLearningAssetVersions } from "../hooks/useLearningAssetVersions";

const FIELD_GUIDE_INTRO =
  "Scenario categories are topic themes (e.g., Travel, Food, Professional) used to generate personalized practice conversations tailored to your interests and goals.";

const FIELD_GUIDE = [
  {
    label: "Category",
    description: 'User-facing display category name (e.g., "Your Travel Toolkit", "Discover Local Flavors") ',
  },
  {
    label: "Category Description",
    description:
      'Brief explanation of what scenarios in this category cover (not shown to user) (e.g., "Essential conversations for confident exploration")',
  },
];

const getLabel = ({ name }: AiccScenarioCategory | AiccScenarioCategoryPayload) => name;

function ScenarioCategoryManagement() {
  const state = useLearningAssetVersions(aiccScenarioCategoryApi.fetchVersions);
  const { isEditable, canDelete, isSaving, runWrite } = state;

  const { isModalVisible, editingItem, openModal, closeModal, handleDelete, handleSubmit } = useAssetCrud<
    AiccScenarioCategory,
    AiccScenarioCategoryPayload
  >({ api: aiccScenarioCategoryApi, runWrite, getLabel });

  const columns = useMemo(() => getColumns({ isEditable, canDelete, onEdit: openModal, onDelete: handleDelete }), [
    isEditable,
    canDelete,
    openModal,
    handleDelete,
  ]);

  return (
    <LearningAssetPage<AiccScenarioCategory>
      title="Scenario Category"
      fieldGuideIntro={FIELD_GUIDE_INTRO}
      fieldGuide={FIELD_GUIDE}
      addText="+ Add Scenario Category"
      columns={columns}
      state={state}
      onAdd={() => openModal()}
    >
      <ScenarioCategoryModal
        visible={isModalVisible}
        category={editingItem}
        isSaving={isSaving}
        onCancel={closeModal}
        onSubmit={handleSubmit}
      />
    </LearningAssetPage>
  );
}

export default ScenarioCategoryManagement;
